// extracted by mini-css-extract-plugin
export default {"greetings":"styles_greetings__kLyrQ","description":"styles_description__trBmJ","ask-for-access":"styles_ask-for-access__pEfUd","image":"styles_image__Mzu1M"};